/**
 * Buttons that show a price next to their label (`primary-button--split`)
 * carry two spans: `[data-button-label]` and `[data-button-price]`. State
 * changes ("Adding to Cart…", "Next Item", errors) must replace only the label,
 * or the price and the layout are lost. Buttons without those spans fall back
 * to plain textContent, so the helpers are safe to use on any button.
 */

export function getButtonLabel(button: HTMLElement): string {
  const label = button.querySelector("[data-button-label]");
  return (label ?? button).textContent ?? "";
}

export function setButtonLabel(button: HTMLElement, text: string): void {
  const label = button.querySelector("[data-button-label]");
  if (label) {
    label.textContent = text;
  } else {
    button.textContent = text;
  }
}

/** Show or hide the price span, for states where a price makes no sense. */
export function setButtonPriceVisible(button: HTMLElement, visible: boolean): void {
  const price = button.querySelector("[data-button-price]");
  if (price instanceof HTMLElement) price.hidden = !visible;
}
